import React from 'react';
import { connect } from 'react-redux';
import CollectMail from './stepper_collectMail';

class NeedToCollectMail extends React.Component {
	constructor(props) {
	  super(props);
	  this.state = { isLogged:false, firstname:'', lastname:'', email:'' };
	}
	
  render(){
		 const {showModal, modalOpen, modalClose, onSubmit_isLogged}= this.props;
		 return (
			<CollectMail 
				open={showModal}
				modalOpen = {modalOpen}
				modalClose = {modalClose}
				onSubmit={onSubmit_isLogged}
			/>
		);
	}
}

export default connect(null)(NeedToCollectMail);
